/**
 * Retrieves the latest released ad creatives for specified channels.
 *
 * @param {Object} params - The parameters object.
 * @param {Object[]} params.adCreatives - Array of ad creatives.
 * @param {string[]} params.channels - Array of channel names.
 * @returns Array of the latest released ad creatives for the specified channels.
 */
function getLatestsReleasedChannelAdCreatives({ adCreatives, channels }) {
  // Get released ad creatives for a channel
  const releasedChannelAdCreatives = adCreatives.filter(
    (obj) => obj.type === "released" && channels.includes(obj.channel)
  );

  // Retrieves all the ad creatives versions
  const releasedChannelAdCreativesVersions = releasedChannelAdCreatives
    .map((ac) => ac.releasedVersion)
    .filter((version) => version !== undefined);
  // Finds the latest ad creative version
  const latestVersion = Math.max(...releasedChannelAdCreativesVersions);

  // Gets all the released ad creatives with the latest version
  const latestReleasedChannelAdCreatives = releasedChannelAdCreatives.filter(
    (ac) => ac.releasedVersion === latestVersion
  );

  return latestReleasedChannelAdCreatives;
}

/**
 * Excludes URLs that are Facebook Graph API endpoints.
 *
 * @param {string} url - The URL to be checked.
 * @returns {string|null} The original URL if it is not a Facebook, otherwise null.
 */
function excludeFacebookPageUrls(url) {
  if (!url || url.includes("http://graph.facebook.com")) {
    return null;
  }

  return url;
}

module.exports = {
  getLatestsReleasedChannelAdCreatives,
  excludeFacebookPageUrls
};
